import { Button } from '@material-ui/core';
import { GenericHeader, SearchBar } from 'components';
import React from 'react';
import { Product } from 'services';
import { CreateModal, Results } from './components';
import ListComp from 'components/ListComp';

const ClassPassList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader header="All Class Passes" subheader="Class Pass Management" {...rest} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Class Pass
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Product.list}
      title="Class Passes"
      name="class_passes"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "pass_purchase" }}
    />
  );
};

export default ClassPassList;
